<template>
	<div class="display raffle-container">
		<Streamer
			ref="streamer"
			:width="'100%'"
			:height="'100%'"
			:class="{ hide: !showStreamer, show: showStreamer }"
		/>
		<LiveRaffle
			:raffleInfo="raffleInfo"
			v-model:readyToVideo="readyToReceive"
			v-model:showStreamer="showStreamer"
		/>
	</div>
</template>

<script>
	import LiveRaffle from '@core/components/raffle/live/LiveRaffle.vue';
	import SelectRaffleSide from '@core/components/raffle/live/SelectRaffleSide.vue';
	import LiveAdminPanel from '@core/components/raffle/live/LiveAdminPanelComponent.vue';
	import PreSelectedRaffle from '@core/components/raffle/PreSelectedRaffle.vue';
	import Streamer from '@/components/Streamer.vue';
	import auth from '@core/services/auth';

	export default {
		name: 'CashbashDisplay',
		data() {
			return {
				liveRaffle: null,
				isHost: false,
				isGame: false,
				raffleInfo: null,
				readyToReceive: false,
				showStreamer: false,
			};
		},
		computed: {},
		created() {
			this.$watch(
				() => this.readyToReceive,
				newValue => {
					if (!newValue) {
						if (this.$refs.streamer.sourceBuffer) {
							this.$refs.streamer.sourceBuffer.abort();
						}
					}
				},
				{ deep: true },
			);
		},
		mounted() {
			import('@static/css/cashBash.css');
		},
		methods: {},
		components: {
			LiveRaffle,
			Streamer,
		},
	};
</script>
